import { isDefined } from './is-defined.guard';

/**
 * Type guard that checks if the provided value is a function.
 *
 * This function verifies that the value is defined, has a type of 'function',
 * its constructor's name is 'Function', and it is an instance of Function.
 *
 * @param value - The value to check.
 * @returns True if the value is a function, otherwise false.
 */
export function isFunction(value: unknown): value is CallableFunction {
  return (
    isDefined(value) &&
    typeof value === 'function' &&
    value.constructor.name === 'Function' &&
    typeof value === 'function'
  );
}
